export default "__VITE_ASSET__Bu0Sni58__"